class JwtExpiredError extends Error {
  constructor(message: string) {
    super(message);
    this.name = `JwtExpiredError`;
  }
}

export default JwtExpiredError;
